import React from "react";
import PropTypes from "prop-types";
import Dispatcher from "../../dispatcher";
import BookStore from "../../stores/book-store";
import BookPlaceholder from "./book-placeholder";

class BookContainer extends React.Component {
  constructor(props) {
    super(props);

    this._bookChange = this._bookChange.bind(this);
  }

  componentDidMount() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 1);
    Dispatcher.bind(Dispatcher.BOOK_CHANGE, this._bookChange);
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_CHANGE, this._bookChange);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 1);
  }

  _bookChange() {
    this.forceUpdate();
  }

  renderAccessDeniedMessage() {
    if (Fraction.Brand.Store.visible) {
      let message = i18n.t("reader.book-access-denied-details", {
        store_url: Fraction.Brand.Store.url
      });
      if (Fraction.Brand.Reader.noBookAccessCopy) {
        message = Fraction.Brand.Reader.noBookAccessCopy;
      }
      return <div className="book-error-details">{window.toHTML(message)}</div>;
    }
  }

  renderRebuilding() {
    return (
      <div
        id="book-wrapper"
        className={"book-error " + this.props.scrubber_expanded}
      >
        <div className="book-slide">
          <div id="book-container" />
          <div id="book-error-message">
            <img
              src={`${Fraction.Environment.coversHost}/vbid/${this.props.isbn}/width/200`}
            />
            <div className="book-error-description">
              {i18n.t("reader.book-rebuilding")}
              {this.renderAccessDeniedMessage()}
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInexistentBook() {
    return (
      <div
        id="book-wrapper"
        className={"book-error " + this.props.scrubber_expanded}
      >
        <div id="book-error-message">
          <img
            src={`${Fraction.Environment.coversHost}/vbid/${this.props.isbn}/width/200`}
          />
          <div className="book-error-description">
            {i18n.t("reader.book-dne")}
            <div className="book-error-details" />
          </div>
        </div>
      </div>
    );
  }

  renderAccessDenied() {
    return (
      <div
        id="book-wrapper"
        className={"book-error " + this.props.scrubber_expanded}
      >
        <div id="book-error-message">
          <img
            src={`${Fraction.Environment.coversHost}/vbid/${this.props.isbn}/width/200`}
          />
          <div className="book-error-description">
            {i18n.t("reader.book-access-denied")}
            {this.renderAccessDeniedMessage()}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const book = BookStore.get(this.props.isbn);
    if (book.bookIsRebuilding) {
      return this.renderRebuilding();
    } else if (book.bookDoesNotExist) {
      return this.renderInexistentBook();
    } else if (book.bookAccessDenied) {
      return this.renderAccessDenied();
    }

    return (
      <div
        id="book-wrapper"
        className={this.props.scrubber_expanded}
        style={this.props.bookHorizontalBounds}
      >
        <BookPlaceholder isbn={this.props.isbn} />
      </div>
    );
  }
}

BookContainer.propTypes = {
  isbn: PropTypes.string.isRequired,
  scrubber_expanded: PropTypes.string
};

BookContainer.defaultProps = {};

module.exports = BookContainer;
